import { ArrowRight, CalendarCheck } from "lucide-react";

const GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSc1jDfsBoci1VGf3xZniRsxsgCGi8PBPO5lXzw6hm8XIAdBuA/viewform?usp=send_form";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_obiter-clat/artifacts/lfcvtw4r_PHOTO-2026-01-28-20-29-49.jpg";

export default function HeroSection() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="min-h-screen flex items-center bg-white pt-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left Content - 7 cols */}
          <div className="lg:col-span-7 space-y-8">
            <div className="inline-flex items-center gap-2 bg-orange-50 border border-orange-100 rounded-full px-4 py-1.5">
              <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
              <span className="text-sm font-body font-medium text-orange-700 tracking-wide">
                Limited Seats Available
              </span>
            </div>

            <h1
              data-testid="hero-headline"
              className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-zinc-900 tracking-tight leading-[1.1]"
            >
              Mentorship-Led{" "}
              <span className="text-orange-600">CLAT Preparation.</span>
              <br />
            </h1>

            <p
              data-testid="hero-subheading"
              className="font-body text-base md:text-lg text-zinc-500 leading-relaxed max-w-xl"
            >
              Prepare for CLAT UG with a clear plan, personal guidance, and 
              focused mentorship — because your journey deserves direction, not confusion.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={GOOGLE_FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-apply-btn"
                className="btn-lift inline-flex items-center justify-center gap-2 bg-orange-600 hover:bg-orange-700 text-white font-medium px-8 py-4 rounded-full transition-all text-base"
              >
                Apply for Upcoming Batch
                <ArrowRight size={18} strokeWidth={1.5} />
              </a>
              <a
                href={GOOGLE_FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-strategy-btn"
                className="btn-lift inline-flex items-center justify-center gap-2 bg-orange-50 text-orange-700 hover:bg-orange-100 border border-orange-200 font-medium px-8 py-4 rounded-full transition-all text-base"
              >
                <CalendarCheck size={18} strokeWidth={1.5} />
                Free Strategy Session
              </a>
            </div>

            {/* Trust indicators */}
            <div className="flex flex-wrap items-center gap-6 pt-4 text-sm font-body text-zinc-400">
              <span className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-orange-400 rounded-full"></span>
                Max 30 Students
              </span>
              <span className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-orange-400 rounded-full"></span>
                Personal Mentorship
              </span>
              <span className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-orange-400 rounded-full"></span>
                Strategy-First
              </span>
            </div>
          </div>

          {/* Right - Logo/Visual - 5 cols */}
          <div className="lg:col-span-5 flex justify-center lg:justify-end">
            <div className="relative">
              <div className="w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 rounded-full bg-orange-50 flex items-center justify-center">
                <img
                  src={LOGO_URL}
                  alt="The Obiter Logo"
                  data-testid="hero-logo"
                  className="w-48 h-48 md:w-60 md:h-60 lg:w-72 lg:h-72 rounded-full object-cover shadow-lg shadow-orange-100/50"
                />
              </div>
              {/* Decorative elements */}
              <div className="absolute -top-4 -right-4 w-20 h-20 border-2 border-orange-200 rounded-full opacity-40"></div>
              <div className="absolute -bottom-6 -left-6 w-14 h-14 border-2 border-orange-200 rounded-full opacity-30"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
